(() => {
  const TARGET_ID = 'offers';
  const OFFSET = 8;
  let activeJump = null;

  function cancelActiveJump() {
    if (!activeJump) return;
    activeJump.timers.forEach((timer) => window.clearTimeout(timer));
    activeJump.imageCleanups.forEach((cleanup) => cleanup());
    activeJump.intentCleanups.forEach((cleanup) => cleanup());
    activeJump = null;
  }

  function getTargetTop(target) {
    return Math.max(0, window.scrollY + target.getBoundingClientRect().top - OFFSET);
  }

  function correctOnce(target, jump) {
    if (!activeJump || activeJump !== jump || jump.cancelled) return;
    const delta = target.getBoundingClientRect().top - OFFSET;
    if (Math.abs(delta) > 2) {
      window.scrollBy({ top: delta, left: 0, behavior: 'auto' });
    }
  }

  function keepAccurateUntilUserScrolls(target) {
    cancelActiveJump();

    const jump = {
      cancelled: false,
      timers: [],
      imageCleanups: [],
      intentCleanups: []
    };
    activeJump = jump;

    const cancelForUserIntent = () => {
      jump.cancelled = true;
      cancelActiveJump();
    };

    ['wheel', 'touchstart', 'pointerdown', 'keydown'].forEach((type) => {
      window.addEventListener(type, cancelForUserIntent, { capture: true, passive: true, once: true });
      jump.intentCleanups.push(() => window.removeEventListener(type, cancelForUserIntent, true));
    });

    // Correct only while the visitor has not tried to scroll. These short checks
    // handle lazy images changing the document height after the first click.
    [80, 180, 350, 650, 1000, 1500, 2200].forEach((delay) => {
      jump.timers.push(window.setTimeout(() => correctOnce(target, jump), delay));
    });

    const targetTop = window.scrollY + target.getBoundingClientRect().top;
    Array.from(document.images).forEach((img) => {
      if (img.complete) return;
      const imageTop = window.scrollY + img.getBoundingClientRect().top;
      if (imageTop >= targetTop) return;

      const onSettled = () => correctOnce(target, jump);
      img.addEventListener('load', onSettled, { once: true });
      img.addEventListener('error', onSettled, { once: true });
      jump.imageCleanups.push(() => {
        img.removeEventListener('load', onSettled);
        img.removeEventListener('error', onSettled);
      });
    });

    jump.timers.push(window.setTimeout(cancelActiveJump, 2400));
  }

  function scrollToOffers(event) {
    const anchor = event.target.closest('a');
    if (!anchor) return;

    const rawHref = (anchor.getAttribute('href') || '').trim();
    const explicit = anchor.hasAttribute('data-cz-scroll-offers');
    const localAnchor = rawHref === '#offers';

    if (!explicit && !localAnchor) return;

    const target = document.getElementById(TARGET_ID);
    if (!target) return;

    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }

    window.scrollTo({ top: getTargetTop(target), left: 0, behavior: 'auto' });
    keepAccurateUntilUserScrolls(target);

    // Keep the page/query URL but remove the active hash so later layout changes cannot
    // cause another native anchor restoration.
    try {
      if (window.history && window.history.replaceState) {
        window.history.replaceState(
          window.history.state,
          '',
          window.location.pathname + window.location.search
        );
      }
    } catch (_) {}
  }

  // Capture phase keeps Shopify preview/editor click handlers from hijacking the anchor.
  document.addEventListener('click', scrollToOffers, true);
})();
